import { PlusIcon } from '@blocksuite/icons/rc';
import { MenuItem } from '@pique/component/ui/menu';
import { useI18n } from '@pique/i18n';

import * as styles from './index.css';

export const AddWorkspace = ({
  onNewWorkspace,
}: {
  onAddWorkspace?: () => void;
  onNewWorkspace?: () => void;
}) => {
  const t = useI18n();

  return (
    <div>
      <MenuItem
        block={true}
        prefixIcon={<PlusIcon />}
        onClick={onNewWorkspace}
        data-testid="new-workspace"
        className={styles.ItemContainer}
      >
        <div className={styles.ItemText}>
          {runtimeConfig.allowLocalWorkspace
            ? t['com.pique.workspaceList.addWorkspace.create']()
            : t['com.pique.workspaceList.addWorkspace.create-cloud']()}
        </div>
      </MenuItem>
    </div>
  );
};
